import { Entity, Key } from '@briebug/ngrx-auto-entity';

@Entity({
  modelName: 'Kudos',
  uriName: 'kudos',
})
export class Kudos {
  @Key id?: number;
  workOrderId!: string;
  reasons!: KudosReason[];

  professionalism?: number;
  dependability?: number;
  punctuality?: number;
  quality?: number;
  attitude?: number;
  timelyCommunication?: number;
  likelyToUseAgain?: number;
}

export enum KudosReason {
  Default = 'NOT_PROVIDED',
  Professionalism = 'PROFESSIONALISM',
  Dependability = 'DEPENDABILITY',
  Punctuality = 'PUNCTUALITY',
  Quality = 'QUALITY',
  Attitude = 'ATTITUDE',
  TimelyCommunication = 'TIMELY_COMMUNICATION',
  LikelyToUseAgain = 'LIKELY_TO_USE_AGAIN',
}
